import {SvgIcon} from "@mui/material";


export function BreadLoafIcon() {
  return (
   <SvgIcon sx={{width: 18, height: 18}}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="#b96622" width="200" height="200" viewBox="0 0 50 50" stroke="#b96622">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"/>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"/>
      <g id="SVGRepo_iconCarrier">
        <path d="M47 8C47 14.800781 41.023438 22.121094 32.039063 31.15625C22.839844 40.402344 15.398438 47 8.707031 47C5.574219 47 3 44.777344 3 39.027344C3 34.574219 4.910156 30.039063 5.886719 28.476563C6.210938 27.960938 15.746094 30.992188 17.335938 29.148438C18.585938 27.699219 9.835938 23.929688 6.117188 26.894531C6.117188 21.519531 9.460938 20.117188 12.042969 19.492188C15.160156 18.730469 24.652344 24.105469 26.597656 21.5625C28.324219 19.304688 17.355469 14.050781 13.734375 17.871094C13.734375 11.914063 18.855469 11.4375 21.789063 11.4375C24.71875 11.4375 34.003906 15.648438 34.003906 13C34.003906 10.027344 26.851563 8.136719 23.246094 9.609375C23.246094 4.5625 30.921875 5.023438 32.351563 5.296875C34.421875 4.191406 37.421875 3 40 3C43.175781 3 47 4.199219 47 8Z"/>
      </g>
    </svg>
   </SvgIcon>
  )
}